<form [formGroup]="newItemsForm">
    <div class="add-new-item-dialog">
        <div>  <p class="add-new-item-to-header-text section-headers">PRODUCT LINE</p></div>
        <div class="add-item-sub-header-text-container"><p class="add-item-sub-header-text">Add or edit a product in this order.</p></div>


        <div class="plant-product-input-container">
            <div class="add-new-item-inputs-container">
                <div class="add-new-item-inputs" >
                    <mat-form-field class="add-new-item-cal-input add-item-input-space" appearance="outline">
                        <mat-label class="LABEL" *ngIf="!isItemEditMode" appRemoveAriaOwns>Select a Plant</mat-label>
                        <mat-select class="new-order-dropdown-2" formControlName="plantId"   #singleSelect>
                            <mat-option style="background-color: white!important; padding: 8px!important">
                                <div class="select-search-container-max">
                                  <div class="select-search-max">
                            <ngx-mat-select-search placeholderLabel="Search Plant" [formControl]="plantFilterCtrl" style="width: 600px;">
                                <span ngxMatSelectNoEntriesFound>
                                    No entries found
                                </span>
                            </ngx-mat-select-search>
                                  </div>
                                </div>
                          </mat-option>
                    
                          <mat-option *ngFor="let plantItem of filteredPlants | async" [value]="plantItem.id"  [disabled]="plantItem.deletionIndicator" 
                          (onSelectionChange)="setSelectedPlant(plantItem, $event)"
                         >
                            {{plantItem.plantCode}} - {{plantItem.name}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="ERROR" *ngIf="!newItemsForm.hasError('plantId') && !newItemsForm.hasError('required')">
                            <strong class="item-required-text">Required* - </strong> Must Select a plant
                        </mat-error>
                    </mat-form-field>
                </div>


                <div class="add-new-item-inputs">
                    <mat-form-field class="add-new-item-cal-input add-item-input-space" appearance="outline">
                        <mat-label *ngIf="!isItemEditMode" appRemoveAriaOwns>Select a Product</mat-label>
                        <mat-select  class="new-order-dropdown-2" formControlName="materialPricingId"  placeholder="Material" #singleSelect>
                            <mat-option style="background-color: white!important; padding: 8px!important">
                                <div class="select-search-container-max">
                                  <div class="select-search-max">
                            <ngx-mat-select-search placeholderLabel="Search Product" [formControl]="materialFilterCtrl" style="width: 600px;">
                                <span ngxMatSelectNoEntriesFound>
                                    No entries found
                                </span>
                            </ngx-mat-select-search>
                                  </div>
                                </div>
                        </mat-option>
                    
                        <mat-option *ngFor="let material of filteredMaterials | async | orderBy: 'materialName'" [value]="material.id" (onSelectionChange)="setSelectedMaterial(material)">
                            {{material.materialName}}
                        </mat-option>
                        </mat-select>
                        <mat-error class="ERROR" *ngIf="!newItemsForm.hasError('materialPricingId') && !newItemsForm.hasError('required')">
                            <strong class="item-required-text">Required* - </strong> Must Select a product
                        </mat-error>
                    </mat-form-field>
                </div>


        </div>

        <div class="left-right-coloumn-containers"> 
            <div class="add-new-item-inputs-container-left">
                <!-- <div class="add-new-item-inputs" >
                    <mat-form-field class="add-new-item-cal-input add-item-input-space" appearance="outline">
                        <mat-label class="LABEL" *ngIf="!isItemEditMode" appRemoveAriaOwns>Select a Plant</mat-label>
                        <mat-select class="new-order-dropdown-2" formControlName="plantId"   #singleSelect>
                            <mat-option style="background-color: white!important; padding: 8px!important">
                                <div class="select-search-container-md">
                                  <div class="select-search-md">
                            <ngx-mat-select-search placeholderLabel="Search Plant" [formControl]="plantFilterCtrl" >
                                <span ngxMatSelectNoEntriesFound>
                                    No entries found
                                </span>
                            </ngx-mat-select-search>
                                  </div>
                                </div>
                          </mat-option>
                    
                          <mat-option *ngFor="let plantItem of filteredPlants | async | orderBy: 'name'" [value]="plantItem.id"  [disabled]="plantItem.deletionIndicator" 
                          (onSelectionChange)="setSelectedPlant(plantItem)"
                         >
                            {{plantItem.plantCode}} - {{plantItem.name}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="ERROR" *ngIf="!newItemsForm.hasError('plantId') && !newItemsForm.hasError('required')">
                            <strong class="item-required-text">Required* - </strong> Must Select a plant
                        </mat-error>
                    </mat-form-field>
                </div> -->

                <div class="qty-UoM-input-container">
                    <div class="add-new-qty-UoM-input">
                        <mat-form-field class="add-new-qty-UoM-item-cal-input add-item-input-space" appearance="outline">
                            <mat-label>Qty</mat-label>
                            <input matInput 
                            oninput="if (this.value.length > 11) this.value = this.value.slice(0, 11); 
                            var parts = this.value.split('.'); 
                            parts[0] = parts[0].replace(/[^0-9]/g, ''); 
                            if(parts[1]){parts[1] = parts[1].slice(0, 3); }
                            this.value = parts.join('.'); 
                            if (parseFloat(this.value) > 1000000) this.value = 1000000;"
                                   formControlName="qty" (focus)="onQtyFocus($event)">
                            <mat-error *ngIf="newItemsForm.get('qty').invalid && newItemsForm.get('qty').touched" class="error-notice">
                                <strong class="item-required-text">Required* QTY</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="add-new-qty-UoM-input">
                        <mat-form-field class="add-new-qty-UoM-item-cal-input add-item-input-space" appearance="outline">
                            <mat-label>{{unitOfMeasure}}</mat-label>
                            <input matInput  formControlName="unitOfMeasureId">
                        </mat-form-field>
                    </div>
                </div>



                <div class="list-price-details-container">
                    <p class="list-price-header">List Price:</p> <span class="list-price-text"><p>{{listPrice | currency:'R':'symbol':'1.0-2'}}</p></span>
                </div>


                <div class="add-new-item-inputs">
                    <mat-form-field class="add-new-item-cal-input add-item-input-space" appearance="outline">
                        <mat-label>Net Price</mat-label>
                        <input matInput
                        oninput="if (this.value.length > 11) this.value = this.value.slice(0, 11); 
                        var parts = this.value.split('.');
                        parts[0] = parts[0].replace(/[^0-9]/g, '');
                        if(parts[1]){parts[1] = parts[1].slice(0, 2);} 
                        this.value = parts.join('.');
                        if (parseFloat(this.value) > 1000000) this.value = 1000000;"
                               formControlName="netPrice">
                    </mat-form-field>
                </div>

                <div class="add-new-item-inputs">
                    <mat-form-field class="add-new-item-cal-input add-item-input-space" appearance="outline">
                        <mat-label>Special Discount %</mat-label>
                        <input matInput
                            oninput="if (this.value.length > 7) this.value = this.value.slice(0, 7); 
                            var parts = this.value.split('.');
                            parts[0] = parts[0].replace(/[^0-9]/g, ''); 
                            if(parts[1]){parts[1] = parts[1].slice(0, 3);} 
                            this.value = parts.join('.');
                            if (parseFloat(this.value) > 100) this.value = 100;"

                               formControlName="specialDiscountPercentage">
                    </mat-form-field>
                </div>

                <div class="add-new-item-inputs">
                    <mat-form-field class="add-new-item-cal-input add-item-input-space" appearance="outline">
                        <mat-label>Handling Cost</mat-label>
                        <input matInput
                        oninput="if (this.value.length > 10) this.value = this.value.slice(0, 10); 
                        var parts = this.value.split('.');
                        parts[0] = parts[0].replace(/[^0-9]/g, ''); 
                        if(parts[1]){parts[1] = parts[1].slice(0, 2);} 
                        this.value = parts.join('.');
                        if (parseFloat(this.value) > 1000000) this.value = 1000000;"

                               formControlName="handlingCharge">


                    </mat-form-field>
                </div>

                <div class="unit-container">
                    <p class="item-total-header display-text">Unit Price: <span class="item-total-text"><p class="display-text unit-price-text">{{unitInclDiscountPrice | currency:'R':'symbol':'1.0-2'}}</p></span></p> 
                  <span class="use-unit-span"><button class="use-unit-btn" (click)="setUnitPrice()"><p class="use-unit-text">Use as nett</p></button></span>
                </div>

                <div class="radio-transport-type-container">
                    <div class="radio-transport-container">
                        <div class="radio-transport-group-container">
                            <mat-radio-group formControlName="ownTransport" >
                                <mat-radio-button [value]="isOwnTransport" (click)="isOwnTransportCheck()">Own Transport</mat-radio-button>
                                <span class="radio-transport-splitter"> | </span>
                                <mat-radio-button [value]="isYaraTransport" (click)="isYaraTransportCheck()">Yara Transport</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>

                <div class="radius-details-container"  [ngClass]="isYaraTransport ? 'radius-details-container' : 'radius-details-container-b'">
                    <!-- <p class="radius-header">Radius:</p>  -->
                    <!-- <span class="radius-text"><p>{{radius}}</p></span> -->
                    <div class="radius-input-container">
                        <mat-form-field class="radius-input" appearance="outline">
                            <mat-label>Radius</mat-label>
                            <input nxNoScroll matInput formControlName="radius" (focusout)="checkRadiusValue()" type="number" (input)="onRadiusUpdate($event)">
                            <mat-error *ngIf="newItemsForm.get('radius').invalid && newItemsForm.get('radius').touched"  class="error-notice">
                                <strong class="item-required-text">Required* - </strong> Should be between 0 and 70
                            </mat-error>
                        </mat-form-field>
                    </div>

                </div>
                    <!-- <div class="straal-container">
                        <mat-form-field class="straal-input input-space" appearance="outline">
                            <mat-label class="custom-label">Radius</mat-label>
                            <input nxNoScroll matInput formControlName="radius" (focusout)="checkRadiusValue()" type="number">
                            <mat-error *ngIf="newOrderForm.get('radius').invalid && newOrderForm.get('radius').touched"  class="error-notice">
                                <strong class="item-required-text">Required* - </strong> Should be between 0 and 70
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div> -->

                <div class="weight-range-main-container" *ngIf="isYaraTransport">
                    <div class="weight-range-container-A">
                        <div class="weight-range-A">  <p class="weight-range-header">20-34</p> <p class="weight-range-header">{{deliveryLookup ? deliveryLookup.largeUom.description : placeholder}}</p></div>
                        <div class="weight-range-value-A"><p class="weight-range-text">{{delLookuplarge}}/{{deliveryLookup ? deliveryLookup.largeUom.description : ''}}</p></div>
                    </div>

                    <div class="weight-range-container-B">
                        <div class="weight-range-B"><p class="weight-range-header">8-19.99</p> <p class="weight-range-header">{{deliveryLookup ? deliveryLookup.mediumUom.description : placeholder}}</p></div>
                        <div class="weight-range-value-B"><p class="weight-range-text">{{delLookupMedium}}/{{deliveryLookup ? deliveryLookup.mediumUom.description : ''}}</p></div>

                    </div>
                </div>


                <div class="add-new-item-action-btn-container">
                    <div class="cancel-item-btn-container">
                        <button class="cancel-item-btn" mat-flat-button type="button" (click)="cancelAddingItem()">
                            <div class="cancel-item-btn-content">
                                <span><p class="cancel-item-btn-text">CANCEL</p></span>
                            </div>
                        </button>
                    </div>

                    <div class="add-item-btn-container">
                        <button class="add-item-btn" mat-flat-button type="button" (click)="addNewItem()" *ngIf="!isItemEditMode; else editMode">
                            <div class="add-item-btn-content">
                                <img src="../../../../../assets/order-to-cash-icons/add_icon.svg" alt="Add Icon" class="add-items-cost-bd-icon">
                                <span><p class="add-item-btn-text">ADD ITEM</p></span>
                            </div>
                        </button>
                        <ng-template #editMode>
                            <button class="add-item-btn" mat-flat-button type="button" (click)="updateItem()">
                                <div class="add-item-btn-content">
                                    <span><p class="add-item-btn-text">UPDATE ITEM</p></span>
                                </div>
                            </button>
                        </ng-template>

                    </div>

                </div>

            </div>


            <div class="add-new-item-inputs-container-right">
                <!-- <div class="add-new-item-inputs">
                    <mat-form-field class="add-new-item-cal-input add-item-input-space" appearance="outline">
                        <mat-label *ngIf="!isItemEditMode" appRemoveAriaOwns>Select a Product</mat-label>
                        <mat-select  class="new-order-dropdown-2" formControlName="materialPricingId"  placeholder="Material" #singleSelect>
                            <mat-option style="background-color: white!important; padding: 8px!important">
                                <div class="select-search-container-md">
                                  <div class="select-search-md">
                            <ngx-mat-select-search placeholderLabel="Search Product" [formControl]="materialFilterCtrl">
                                <span ngxMatSelectNoEntriesFound>
                                    No entries found
                                </span>
                            </ngx-mat-select-search>
                                  </div>
                                </div>
                        </mat-option>
                    
                        <mat-option *ngFor="let material of filteredMaterials | async | orderBy: 'materialName'" [value]="material.id" (onSelectionChange)="setSelectedMaterial(material)">
                            {{material.materialName}}
                        </mat-option>
                        </mat-select>
                        <mat-error class="ERROR" *ngIf="!newItemsForm.hasError('materialPricingId') && !newItemsForm.hasError('required')">
                            <strong class="item-required-text">Required* - </strong> Must Select a product
                        </mat-error>
                    </mat-form-field>
                </div> -->


                <div class="add-new-item-inputs">
                    <mat-form-field class="add-new-item-cal-input add-item-input-space" appearance="outline">
                        <mat-label>1St Delivery Date</mat-label>
                        <input matInput [matDatepicker]="firstDelDate"  [min]="minDate"  formControlName="firstDeliveryDate">
                        <mat-datepicker-toggle matIconSuffix [for]="firstDelDate"></mat-datepicker-toggle>
                        <mat-datepicker #firstDelDate></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="add-new-item-inputs-spacer">

                </div>

                <div class="required-product-checkbox-container">
                    <mat-checkbox formControlName="isCustomProductMixing" class="required-product-checkbox" (click)="toggleIsMixingRequired()">Required Product Mixing</mat-checkbox>
                </div>

                <div class="add-new-item-inputs">
                    <mat-form-field class="add-new-item-cal-input add-item-input-space" appearance="outline">
                        <mat-label>Trade Discount %</mat-label>
                        <input matInput
                                oninput="if (this.value.length > 7) this.value = this.value.slice(0, 7); 
                                var parts = this.value.split('.');
                                parts[0] = parts[0].replace(/[^0-9]/g, ''); 
                                if(parts[1]){ parts[1] = parts[1].slice(0, 3);} 
                                this.value = parts.join('.');
                                if (parseFloat(this.value) > 100) this.value = 100;"

                        formControlName="tradeDiscountPercentage">
                    </mat-form-field>
                </div>

                <div class="add-new-item-inputs">
                    <mat-form-field class="add-new-item-cal-input add-item-input-space" appearance="outline" *ngIf="isYaraTransport">
                        <mat-label>Transport Cost</mat-label>
                        <input matInput
                                oninput="if (this.value.length > 10) this.value = this.value.slice(0, 10); 
                                var parts = this.value.split('.');
                                parts[0] = parts[0].replace(/[^0-9]/g, ''); 
                                if(parts[1]){parts[1] = parts[1].slice(0, 2);}
                                this.value = parts.join('.');
                                if (parseFloat(this.value) > 1000000) this.value = 1000000;"

                               formControlName="transportExpense">
                    </mat-form-field>
                </div>

                <div class="item-total-details-container">
                    <p class="item-total-header display-text">Item Total:</p> <span class="item-total-text"><p class="display-text">{{itemTotal | currency:'R':'symbol':'1.0-2'}}</p></span>
                    <p class="item-discount-total-header display-text">Discount Pct:</p> <span class="item-discount-total-text"><p class="display-text">{{itemTotalDiscountPercentage}}%</p></span>
                </div>

                <div class="item-total-details-container">
                    <p class="item-total-header display-text">Order Total TNE:</p> <span class="item-total-text"><p class="display-text">{{currentTotalTNE | number:'1.0-3'}} TNE</p></span>
                </div>

                <div  class="tons-metric-container" *ngIf="isYaraTransport">

                    <div class="results-per-ton-container">
                        <p class="results-per-ton-text">*Results per TON/Load</p>
                    </div>



                    <div class="tons-delivered-container">
                        <p class="tons-delivered-text">< 8 TONS DELIVERED TO</p>
                    </div>

                    <div class="number-of-farms-container">
                        <div class="number-of-farms-per-ton">
                            <div class="number-of-farms-per-ton-header">
                                <p class="weight-range-header">1 Farm</p>
                                <p class="weight-range-header">2/MORE</p>
                            </div>
                            <div class="number-of-farms-per-ton-cost-container">
                                <div class="one-farm-per-ton-cost">
                                    <p class="weight-range-text">{{calculatedSingleSmallFarm}}/ <span *ngIf="calculatedSingleSmallFarm">TNE</span></p>
                                </div>
                                <div class="two-farm-per-ton-cost">
                                    <p class="weight-range-text">{{calculatedMultiSmallFarm}}/ <span *ngIf="calculatedSingleSmallFarm">TNE</span></p>
                                </div>
                            </div>
                        </div>

                        <div class="number-of-farms-per-load">
                            <div class="number-of-farms-per-load-header">
                                <p class="weight-range-header">1 Farm</p>
                                <p class="weight-range-header">2/MORE</p>
                            </div>

                            <div class="number-of-farms-per-load-cost-container">
                                <div class="one-farm-per-load-cost">
                                    <p class="weight-range-text">{{delLookupSingleSmall}}/{{deliveryLookup ? deliveryLookup.smallSingleFarmUom.description : ''}}</p>
                                </div>
                                <div class="two-farm-per-load-cost">
                                    <p class="weight-range-text">{{delLookupMultiSmall}}/{{deliveryLookup ? deliveryLookup.smallMultipleFarmsUom.description : ''}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</form>
